export const actions = {
  BIBFAMILIA_LOAD_REQUESTED: 'BIBFAMILIA_LOAD_REQUESTED',
  BIBFAMILIA_LOAD_SUCCEEDED: 'BIBFAMILIA_LOAD_SUCCEEDED',
  BIBFAMILIA_LOAD_FAILED: 'BIBFAMILIA_LOAD_FAILED',

  BIBFAMILIA_LOAD_BY_ID_REQUESTED: 'BIBFAMILIA_LOAD_BY_ID_REQUESTED',
  BIBFAMILIA_LOAD_BY_ID_SUCCEEDED: 'BIBFAMILIA_LOAD_BY_ID_SUCCEEDED',
  BIBFAMILIA_LOAD_BY_ID_FAILED: 'BIBFAMILIA_LOAD_BY_ID_FAILED',

  BIBFAMILIA_FILTERED_LOAD_REQUESTED: 'BIBFAMILIA_FILTERED_LOAD_REQUESTED',
  BIBFAMILIA_FILTERED_LOAD_SUCCEEDED: 'BIBFAMILIA_FILTERED_LOAD_SUCCEEDED',
  BIBFAMILIA_FILTERED_LOAD_FAILED: 'BIBFAMILIA_FILTERED_LOAD_FAILED',

  BIBFAMILIA_INSERT_REQUESTED: 'BIBFAMILIA_INSERT_REQUESTED',
  BIBFAMILIA_INSERT_SUCCEEDED: 'BIBFAMILIA_INSERT_SUCCEEDED',
  BIBFAMILIA_INSERT_FAILED: 'BIBFAMILIA_INSERT_FAILED',

  BIBFAMILIA_UPDATE_REQUESTED: 'BIBFAMILIA_UPDATE_REQUESTED',
  BIBFAMILIA_UPDATE_SUCCEEDED: 'BIBFAMILIA_UPDATE_SUCCEEDED',
  BIBFAMILIA_UPDATE_FAILED: 'BIBFAMILIA_UPDATE_FAILED',

  DELETE_BIBLIOTECA_FAMILIA_REQUESTED: 'DELETE_BIBLIOTECA_FAMILIA_REQUESTED',
  DELETE_BIBLIOTECA_FAMILIA_SUCCEEDED: 'DELETE_BIBLIOTECA_FAMILIA_SUCCEEDED',
  DELETE_BIBLIOTECA_FAMILIA_FAILED: 'DELETE_BIBLIOTECA_FAMILIA_FAILED',

  PEGATINA_FAMILIA_INSERTED: 'PEGATINA_FAMILIA_INSERTED',
  PEGATINA_FAMILIA_UPDATED: 'PEGATINA_FAMILIA_UPDATED',
  PEGATINA_FAMILIA_DELETED: 'PEGATINA_FAMILIA_DELETED',

  BIBFAMILIA_PRODUCTO_UPDATE_REQUESTED: 'BIBFAMILIA_PRODUCTO_UPDATE_REQUESTED',
  BIBFAMILIA_PRODUCTO_UPDATE_SUCCEEDED: 'BIBFAMILIA_PRODUCTO_UPDATE_SUCCEEDED',
  BIBFAMILIA_PRODUCTO_UPDATE_FAILED: 'BIBFAMILIA_PRODUCTO_UPDATE_FAILED',

  BIBFAMILIA_PRODUCTO_BY_ID_REQUESTED: 'BIBFAMILIA_PRODUCTO_BY_ID_REQUESTED',
  BIBFAMILIA_PRODUCTO_BY_ID_SUCCEEDED: 'BIBFAMILIA_PRODUCTO_BY_ID_SUCCEEDED',
  BIBFAMILIA_PRODUCTO_BY_ID_FAILED: 'BIBFAMILIA_PRODUCTO_BY_ID_FAILED',
}

export const getBibFamiliaAction = dispatch => {
  dispatch({
    type: actions.BIBFAMILIA_LOAD_REQUESTED,
  })
}

export const getBibFamiliaByIdAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBFAMILIA_LOAD_BY_ID_REQUESTED,
    payload: id,
  })
}

export const getBibFamiliaFilteredAction = (dispatch, filter) => {
  dispatch({
    type: actions.BIBFAMILIA_FILTERED_LOAD_REQUESTED,
    payload: filter,
  })
}

export const insertBibFamiliaAction = (dispatch, payload) => {
  dispatch({
    type: actions.BIBFAMILIA_INSERT_REQUESTED,
    payload,
  })
}

export const updateBibFamiliaAction = (dispatch, payload) => {
  dispatch({
    type: actions.BIBFAMILIA_UPDATE_REQUESTED,
    payload,
  })
}

export const deleteBibliotecaFamiliaAction = (dispatch, payload) => {
  dispatch({
    type: actions.DELETE_BIBLIOTECA_FAMILIA_REQUESTED,
    payload,
  })
}

export const pegatinaFamiliaUpdatedAction = (dispatch, payload) => {
  dispatch({
    type: actions.PEGATINA_FAMILIA_UPDATED,
    payload,
  })
}

export const pegatinaFamiliaInsertedAction = (dispatch, payload) => {
  dispatch({
    type: actions.PEGATINA_FAMILIA_INSERTED,
    payload,
  })
}

export const pegatinaFamiliaDeletedAction = (dispatch, payload) => {
  dispatch({
    type: actions.PEGATINA_FAMILIA_DELETED,
    payload,
  })
}

export const updateBibFamiliaProductoAction = (dispatch, payload) => {
  dispatch({
    type: actions.BIBFAMILIA_PRODUCTO_UPDATE_REQUESTED,
    payload,
  })
}

export const getBibFamiliaProductoByIdAction = (dispatch, payload) => {
  dispatch({
    type: actions.BIBFAMILIA_PRODUCTO_BY_ID_REQUESTED,
    payload,
  })
}
